import Vue from 'vue'
import Recruit from './Recruit.vue'
Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import AnimateCss from 'animate.css';
Vue.use(AnimateCss);

import api from '../../../request/api' // 自定义全局请求
Vue.prototype.$api = api;

import DOMPurify from 'isomorphic-dompurify'
Vue.prototype.$purify = DOMPurify;

import '../../../assets/font/myFont.css'

import '../../../assets/css/vue2editor.css'

new Vue({
    render: h => h(Recruit),
}).$mount('#recruit')